//src/pages/reports/reservas/
import { Outlet, NavLink } from 'react-router-dom';
import { Box, Typography, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import TimelineIcon from '@mui/icons-material/Timeline';
import NumbersIcon from '@mui/icons-material/Numbers';
import CancelIcon from '@mui/icons-material/Cancel';
import ScheduleIcon from '@mui/icons-material/Schedule';
import PieChartIcon from '@mui/icons-material/PieChart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DrawIcon from '@mui/icons-material/Draw';
import StackedBarChartIcon from '@mui/icons-material/StackedBarChart';
import ViewTimelineIcon from '@mui/icons-material/ViewTimeline';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { useTranslation } from 'react-i18next';
const linkSx = (active: boolean) => ({
  bgcolor: active ? 'action.selected' : 'transparent',
  color: active ? 'primary.main' : 'text.primary',
  '& .MuiListItemIcon-root': { color: active ? 'primary.main' : 'inherit' },
});

export default function ReservasReportsLayout() {
  const { t } = useTranslation<'translation'>();
  return (
    <Box sx={{ display: 'flex', minHeight: '100%' }}>
      {/* ────────── menú lateral ────────── */}
      <Box
        sx={{
          width: 220,
          borderRight: 1,
          borderColor: 'divider',
          px: 2,
          py: 3,
        }}
      >
        <Typography variant="subtitle1" sx={{ mb: 2 }}>
          {t('reservasReportsLayout.titulo')}
        </Typography>

        <List dense disablePadding>
          <NavLink to="metricas">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <TimelineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.metricas')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="totales">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <NumbersIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.totales')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="canceladas">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <CancelIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.cancelaciones')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="resheat">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ScheduleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.heatmap')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="distribucion">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <PieChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.distribucion')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="progresion">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <TrendingUpIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.progresion')} />
              </ListItemButton>
            )}
          </NavLink>
          {/* Retrasos */}
          <NavLink to="retrasos">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ScheduleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.retrasos')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="firmas">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <DrawIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.firmas')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="carga-formato">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <StackedBarChartIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.cargaFormato')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="utilizacion-capacidad">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ViewTimelineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.utilizacionCapacidad')} />
              </ListItemButton>
            )}
          </NavLink>
          <NavLink to="incidencias-tasa">
            {({ isActive }) => (
              <ListItemButton selected={isActive} sx={linkSx(isActive)}>
                <ListItemIcon>
                  <ReportProblemIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={t('reservasReportsLayout.menu.incidenciasTasa')} />
              </ListItemButton>
            )}
          </NavLink>
        </List>
      </Box>

      {/* ────────── contenido ────────── */}
      <Box sx={{ flex: 1, p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
}
